module.exports = __webpack_public_path__ + "img/2.b86bc658.png";